import colors from '../../../scss/colors';

function CloseButtonIcon({ width, height, color }) {
  return (
    <svg width={width} height={height} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.8"
        d="M22.4907 18L35.0604 5.43032C35.6569 4.83482 35.9925 4.02672 35.9932 3.18381C35.994 2.3409 35.6598 1.53222 35.0643 0.935665C34.4688 0.33911 33.6607 0.00355172 32.8178 0.00280732C31.9749 0.00206292 31.1662 0.336194 30.5697 0.931696L18 13.5014L5.43032 0.931696C4.83376 0.335141 4.02466 0 3.18101 0C2.33735 0 1.52825 0.335141 0.931696 0.931696C0.335141 1.52825 0 2.33735 0 3.18101C0 4.02466 0.335141 4.83376 0.931696 5.43032L13.5014 18L0.931696 30.5697C0.335141 31.1662 0 31.9753 0 32.819C0 33.6626 0.335141 34.4718 0.931696 35.0683C1.52825 35.6649 2.33735 36 3.18101 36C4.02466 36 4.83376 35.6649 5.43032 35.0683L18 22.4986L30.5697 35.0683C31.1662 35.6649 31.9753 36 32.819 36C33.6626 36 34.4718 35.6649 35.0683 35.0683C35.6649 34.4718 36 33.6626 36 32.819C36 31.9753 35.6649 31.1662 35.0683 30.5697L22.4907 18Z"
        fill={color || colors.LIGHT_GREY}
      />
    </svg>
  );
}

export default CloseButtonIcon;
